<template>
  <div class="menu-prof">
    <div class="menu-prof2">
      <div class="container">
        <el-menu :default-active="activeIndex" class="el-menu-prof" mode="horizontal" @select="handleSelect" :router='true'>
          <div style="float:left; margin-top:20px;">
            <router-link to="/">
              <figure class="image ">
                <img class="" src="/img/winnicotti_brasilia_horiz.png" style="height:60px;width:auto;margin-top:-20px;" />
              </figure>
            </router-link>
          </div>
          <el-menu-item route='/' index="1">Início</el-menu-item>
          <el-menu-item route='/p/quem-somos' index="2">Quem Somos</el-menu-item>
          <el-menu-item route='/p/cursos' index="3">Cursos</el-menu-item>
          <el-menu-item route='/p/xii-encontro' index="4">XII Encontro</el-menu-item>
          <el-menu-item route='/p/supervisao' index="5">Supervisão</el-menu-item>
          <el-menu-item route='/p/grupo-de-estudos' index="6">Grupo de Estudos</el-menu-item>
          <el-menu-item route='/p/contato' index="7">Contato</el-menu-item>
          <el-submenu index="8" v-if='showAdminMenu'>
            <template slot="title">Administração</template>
            <el-menu-item route='/admin/cursos' index="8-1">Cursos</el-menu-item>
            <el-menu-item route='/admin/usuarios' index="8-2">Usuários</el-menu-item>
            <el-menu-item route='/admin/xiiencontro' index="8-3">XII Encontro</el-menu-item>
            <el-menu-item route='/session/sair' index="8-4">Sair</el-menu-item>
          </el-submenu>
          <el-submenu index="9" v-if='showUserMenu'>
            <template slot="title">Usuário</template>
            <el-menu-item route='/usuario/cursos' index="9-1">Meus Cursos</el-menu-item>
            <el-menu-item route='/session/sair' index="9-2">Sair</el-menu-item>
          </el-submenu>
          <el-menu-item  v-if='showLoginMenu' route='/p/login' index="10">Entrar</el-menu-item>

        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Store from '@/store'
import moment from 'moment'
import utils from '@/utils'


export default {
    data() {
      return {
        activeIndex: '1',
        links: [],
        state3: '',
        breads: [],
      };
    },
    watch: {
      '$route': function (r) {
        this.loadRoute(r)
      }
    },
    computed:{
      ...mapState({
        showAdminMenu: state => {
          return state.session.auth && state.session.type == 1;
        },
        showUserMenu: state => {
          return state.session.auth && state.session.type == 2;
        },
        showLoginMenu: state => {
          return !state.session.auth;
        },
        disciplinas: state => state.session.disciplinas
      })
    },
    methods: {
      unhideMenu(){
        Store.dispatch('session/unhideMenu', {});
      },
      spliJoinUrl(arr, num){
        const nums = Array.from(Array(num+1).keys());
        const a = arr.split("/");
        const ret = nums.map(x=>{
          return a[x]
        })
        
        return  ret.join("/")

      },
      
      loadRoute(r){
        console.log(r.name)
        
        switch(r.name){
          case 'index':
            this.activeIndex = '1';
          break;
          case 'quem-somos':
            this.activeIndex = '2';
          break;
          case 'cursos':
            this.activeIndex = '3';
          break;
          case 'xii-encontro':
            this.activeIndex = '4';
          break;
          case 'supervisao':
            this.activeIndex = '5';
          break;
          case 'grupo-de-estudos':
            this.activeIndex = '6';
          break;
          case 'contato':
            this.activeIndex = '7';
          break;
          case 'admin-cursos':
            this.activeIndex = '8-1';
          break;
          case 'admin-usuarios':
            this.activeIndex = '8-2';
          break;
          case 'admin-xii-encontro':
            this.activeIndex = '8-3';
          break;
          case 'usuario-cursos':
            this.activeIndex = '9-1';
          break;
           case 'login':
            this.activeIndex = '10';
          break;
          
          default:
            this.activeIndex = '';
        }
        
      },
      querySearch(queryString, cb) {
        var links = this.links;
        var results = queryString ? links.filter(this.createFilter(queryString)) : links;
        // call callback function to return suggestion objects
        cb(results);
      },
      createFilter(queryString) {
        return (link) => {
          return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      loadAll() {
        return [
          { "value": "vue", "link": "https://github.com/vuejs/vue" },
          { "value": "element", "link": "https://github.com/ElemeFE/element" },
          { "value": "cooking", "link": "https://github.com/ElemeFE/cooking" },
          { "value": "mint-ui", "link": "https://github.com/ElemeFE/mint-ui" },
          { "value": "vuex", "link": "https://github.com/vuejs/vuex" },
          { "value": "vue-router", "link": "https://github.com/vuejs/vue-router" },
          { "value": "babel", "link": "https://github.com/babel/babel" }
         ];
      },
      handleSelect(item) {
        
      },
      handleIconClick(ev) {
        
      }
    },
    mounted() {
      this.links = this.loadAll();
      this.loadRoute(this.$route);
     // this.verifyScreen()
    }
  };
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Handlee');
</style>
<style>
  .image{
    width: 250px;
    margin-top:12px;
  }
  .menu-prof2, .el-menu-prof{
    /*height: 90px;*/
  }
  .el-menu-prof li.el-menu-item.is-active{
    border-bottom: 0px!important;
    font-weight: bold; 
    padding: 20px 20px;
    background: #1CA99D!important;
    color:#fff!important;

  }
  .el-menu-prof li.el-submenu.is-active{
    border-bottom: 0px!important;
    font-weight: bold; 
    padding: 20px 20px;
    background: #1CA99D!important;
    color:#fff!important;

  }
  .el-menu-prof li.el-submenu.is-active div{
    border-bottom: 0px!important;
    font-weight: bold; 
    padding: 20px 20px;
    background: #1CA99D!important;
    color:#fff!important;

  }
   .el-menu-prof li.el-menu-item, .el-menu-prof li.el-submenu{
    border-bottom: 0px!important;
    padding: 20px 20px;
    height: 100%;
    padding-top:20px;

  }
  .el-menu-prof li.el-menu-item:first-child{
    margin-right: 20px;

  }
  .button-left-menu{
    position:fixed;
    left: 0px;
    top: 50px;
    z-index:1400;
  }
  .menu-prof2 {
    background:#FFF;
    border-bottom: solid 2px #e6e6e6;
  }
  .menu-prof li {
      line-height: normal;
      padding: 7px;
  }
  .menu-prof .value {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .menu-prof .link {
    font-size: 12px;
    color: #b4b4b4;
  }
</style>
